import ReactDOM from "react-dom";
import VersionSelector from "./views/VersionSelector";

const rootElement = document.getElementById("version-selector-root");
if (rootElement) {
    const modelId = rootElement.dataset.model;
    const title = rootElement.dataset.title;
    const linkData = {
        visible: rootElement.dataset.ctavisible,
        title: rootElement.dataset.ctatitle,
        url: rootElement.dataset.ctaurl,
        opens_in: rootElement.dataset.ctaopens_in,
    };
    const linkCotizador = rootElement.dataset.bnp_page_url;
    const linkConnected = rootElement.dataset.connected_page_url;
    const openInNewTab = rootElement.dataset.connected_page_opens_in_new_tab === "True";
    ReactDOM.render(
        <VersionSelector
            modelId={modelId}
            title={title}
            linkData={linkData}
            linkCotizador={linkCotizador}
            linkConnected={linkConnected}
            openInNewTab={openInNewTab}
        />,
        rootElement,
    );
}
